module.exports = __webpack_public_path__ + "img/theme_title_bg.64be4878.jpg";